export const MOBILE = 'MOBILE';
// Map tileSize prefix to tile sizes
export const TILE_SIZE_MAP = {
	medium: 'md',
	small: 'sm'
};
